import {
  FETCH_LMEXPRESS_REQUEST,
  FETCH_LMEXPRESS_SUCCESS,
  FETCH_LMEXPRESS_ERROR,
  FETCH_LMEXPRESS_PARAMETERS_REQUEST,
  FETCH_LMEXPRESS_PARAMETERS_SUCCESS,
  FETCH_LMEXPRESS_PARAMETERS_ERROR,
  UPDATE_LMEXPRESS_PARAMETERS_REQUEST,
  UPDATE_LMEXPRESS_PARAMETERS_SUCCESS,
  UPDATE_LMEXPRESS_PARAMETERS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  record: {},
  error: null,
  isFetching: false,
  filters: {},
  edit: {
    isUpdating: false,
    updated: false,
    error: null,
  },
  parameters: {
    isUpdating: false,
    error: null,
    records: {},
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_LMEXPRESS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      }

    case FETCH_LMEXPRESS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        record: action.payload,
        filters: action.filters,
      }

    case FETCH_LMEXPRESS_ERROR:
      return {
        ...state,
        isFetching: false,
        record: {},
        error: action.payload,
        filters: action.filters,
      }

    case FETCH_LMEXPRESS_PARAMETERS_REQUEST:
      return {
        ...state,
        parameters: {
          ...state.parameters,
        },
        edit: {
          ...state.edit,
          updated: false,
        },
      }

    case FETCH_LMEXPRESS_PARAMETERS_SUCCESS:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_LMEXPRESS_PARAMETERS_ERROR:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          error: action.payload.error,
        },
      }

    case UPDATE_LMEXPRESS_PARAMETERS_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          updated: false,
          isUpdating: true,
        },
      }

    case UPDATE_LMEXPRESS_PARAMETERS_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          updated: true,
          isUpdating: false,
          error: null,
        },
      }

    case UPDATE_LMEXPRESS_PARAMETERS_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: action.payload.error,
        },
      }
    default:
      return state
  }
}

export default record
